import React from 'react';
import { Navigation } from './Navigation';
import { Footer } from './Footer';

interface BlogLayoutProps {
  children: React.ReactNode;
}

export function BlogLayout({ children }: BlogLayoutProps) {
  return (
    <div className="min-h-screen bg-gradient-to-br from-gray-900 via-purple-900 to-gray-900">
      <Navigation />
      <main className="relative">
        {children}
      </main>
      <Footer />
    </div>
  );
}